import axios from "axios";
// Varsayılan olarak canlı API kullanılır. Yerel backend ile çalışmak için .env.local
// dosyasına REACT_APP_API_URL=http://localhost:3001 gibi bir satır ekleyin.
// (3000 portu React geliştirme sunucusuna ait, backend'i başka bir portta çalıştırın.)
const baseURL =
  process.env.REACT_APP_API_URL || "https://championship-api.herokuapp.com/";

const instance = axios.create({
  baseURL,
  timeout: 50000,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const updateAuthHeaders = (authHeaders) => {
  for (let key in authHeaders)
    instance.defaults.headers.common[key] = authHeaders[key];
};

export const clearHeaders = () => {
  for (let key of ["uid", "access-token", "client"])
    delete instance.defaults.headers.common[key];
};

export default instance;
